import { gql } from "@apollo/client"

const CAREER_PATH = "code name"

export const LL_ROUTE_ACCESS_QUERY = gql`
  query LifelongLearningRouteAccess {
    me {
      id
      lifelongLearning {
        spp {
          status
          eligibility {
            canViewProgress
          }
        }
        cpp {
          status
          eligibility {
            canViewProgress
          }
        }
        mpp {
          status
          eligibility {
            canViewProgress
          }
        }
      }
    }
  }
`

export const LL_PROGRAMS_QUERY = gql`
  query LifelongLearningPrograms {
    me {
      id
      pgaId
      lifelongLearning {
        spp {
          status
          statusStartDate
          statusEndDate
          progressStartDate
          careerPath {
            ${CAREER_PATH}
          }
          progress {
            latestSubscription {
              endDate
            }
          }
          eligibility {
            canRenew
            canViewProgress
            blockers
          }
        }
        cpp {
          status
          statusStartDate
          progressStartDate
          careerPath {
            ${CAREER_PATH}
          }
          progress {
            levelCode
          }
          eligibility {
            canApply
            applyAvailableOn
            blockers
          }
        }
        mpp {
          status
          statusStartDate
          progressStartDate
          careerPath {
            ${CAREER_PATH}
          }
          progress {
            levelCode
          }
          eligibility {
            canApply
            applyAvailableOn
            blockers
          }
        }
      }
    }
  }
`

export const LL_PROGRAM_HISTORY_QUERY = gql`
  query LifelongLearningProgramHistory {
    me {
      id
      lifelongLearning {
        programHistory {
          programCode
          programName
          status
          statusStartDate
          statusEndDate
          current
          careerPath {
            ${CAREER_PATH}
          }
        }
      }
    }
  }
`

export const LL_CPP_DETAIL_QUERY = gql`
  query LifelongLearningCppDetail {
    me {
      id
      pgaId
      lifelongLearning {
        cpp {
          status
          eligibility {
            canOptIn
            blockers
          }
        }
      }
    }
  }
`

export const LL_MPP_DETAIL_QUERY = gql`
  query LifelongLearningMppDetail {
    me {
      id
      pgaId
      lifelongLearning {
        mpp {
          status
          eligibility {
            canOptIn
            blockers
          }
        }
      }
    }
  }
`

export const LL_APPLICATION_INFO_QUERY = gql`
  query LifelongLearningApplicationInfo {
    me {
      id
      pgaId
      lifelongLearning {
        cpp {
          status
          applicationCareerPathOptions {
            careerPath {
              ${CAREER_PATH}
            }
            mappedFrom {
              ${CAREER_PATH}
            }
          }
        }
        mpp {
          status
          applicationCareerPathOptions {
            careerPath {
              ${CAREER_PATH}
            }
            mappedFrom {
              ${CAREER_PATH}
            }
          }
        }
      }
    }
  }
`

export const LL_CPP_PROGRESS_QUERY = gql`
  query LifelongLearningCppProgress {
    me {
      id
      pgaId
      lifelongLearning {
        cpp {
          status
          careerPath {
            code
          }
          progress {
            levelCode
            nextLevelCode
            latestSubscription {
              endDate
              expired
            }
          }
          eligibility {
            canApply
            canEnroll
            tenureMet
            applyAvailableOn
          }
        }
        levels(programCodes: ["CPP3"]) {
          levelCode
          completeCode
        }
        requirements(levelCodes: ["ME3", "MO3", "MT3"]) {
          levelCode
          requireId
          status
        }
        availableActivities(levelCodes: ["ME3", "MO3", "MT3"]) {
          availableCode
          levelCode
          reasonCode
        }
        cpeHours {
          id
          approvedAmount
          careerPathCode
          status
        }
      }
    }
  }
`

export const LL_MPP_PROGRESS_QUERY = gql`
  query LifelongLearningMppProgress {
    me {
      id
      pgaId
      lifelongLearning {
        mpp {
          status
          careerPath {
            code
          }
          progress {
            levelCode
            nextLevelCode
            latestSubscription {
              endDate
              expired
            }
          }
          eligibility {
            canApply
            canEnroll
            tenureMet
            applyAvailableOn
          }
        }
        levels(programCodes: ["MPP3"]) {
          levelCode
          completeCode
        }
        requirements(levelCodes: ["ME5", "MO5", "MT5"]) {
          levelCode
          requireId
          status
        }
      }
    }
  }
`

export const LL_SUBSCRIPTION_BANNER_QUERY = gql`
  query LifelongLearningSubscriptionBanner {
    me {
      id
      pgaId
      lifelongLearning {
        cpp {
          progress {
            levelCode
            latestSubscription {
              endDate
              expired
            }
          }
        }
        mpp {
          progress {
            levelCode
            latestSubscription {
              endDate
              expired
            }
          }
        }
      }
    }
  }
`

export const LL_ENROLL_ACTION_QUERY = gql`
  query LifelongLearningEnrollAction {
    me {
      id
      pgaId
      lifelongLearning {
        cpp {
          application {
            careerPath {
              code
            }
          }
        }
      }
    }
  }
`

export const LL_CURRENT_ENROLLMENT_QUERY = gql`
  query LifelongLearningCurrentEnrollment {
    me {
      id
      lifelongLearning {
        spp {
          status
          eligibility {
            canRenew
            canViewProgress
            blockers
          }
        }
        cpp {
          status
        }
        mpp {
          status
        }
      }
    }
  }
`

export const LL_CPE_HOURS_QUERY = gql`
  query LifelongLearningCpeHours {
    me {
      id
      lifelongLearning {
        cpp {
          careerPath {
            code
          }
        }
        cpeHours {
          id
          description
          approvedAmount
          requestedAmount
          startDate
          endDate
          careerPathCode
          status
        }
      }
    }
  }
`

export const LL_APPLICATION_DECISION_QUERY = gql`
  query LifelongLearningApplicationDecision {
    me {
      id
      pgaId
      lifelongLearning {
        cpp {
          status
          application {
            applicationId
            status
            statusStartDate
            careerPath {
              ${CAREER_PATH}
            }
          }
        }
        mpp {
          status
          application {
            applicationId
            status
            statusStartDate
            careerPath {
              ${CAREER_PATH}
            }
          }
        }
      }
    }
  }
`
